module.exports = __webpack_public_path__ + "static/media/goal.f6d44e25.svg";